import React__default from 'react';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { useIntl, useSelector, statusUninit, statusLoading, statusWarning, statusFailed } from '@grandvisionhq/state';
import { useRxGlassesConfiguratorContext } from '../../Context/RxGlassesConfiguratorContext.js';
import { PrescriptionFormStep } from './PrescriptionFormStep.js';
import { getSelectedFrame, getPrescription, getIsPrescriptionStepValid } from '../../../state/configurator/selectors.js';
import { PRESCRIPTION_STEP_FORM_ERROR_ID } from '../../../state/constants.js';

const PrescriptionFormStepContainer = ()=>{
    const { hasAttemptedNextStep  } = useConfiguratorContext();
    const [errorMessageKey, setErrorMessageKey] = React__default.useState(null);
    const { configuratorDocument  } = useRxGlassesConfiguratorContext();
    const { prescriptionFormStep  } = configuratorDocument || {};
    const { hasLabel , getLabel  } = useIntl();
    const frame = useSelector(getSelectedFrame);
    const prescription = useSelector(getPrescription);
    const isPrescriptionStepValid = useSelector(getIsPrescriptionStepValid);
    const alertLabelKey = 'products.glasses.newPrescriptionRadio.alert';
    React__default.useEffect(()=>{
        if (hasAttemptedNextStep && !isPrescriptionStepValid) {
            setErrorMessageKey('products.glasses.prescription.form.validationError');
            return;
        }
        setErrorMessageKey(null);
    }, [
        hasAttemptedNextStep,
        isPrescriptionStepValid
    ]);
    const isLoading = !prescription || statusUninit(prescription) || statusLoading(prescription);
    const isFailed = !frame || statusWarning(prescription) || statusFailed(prescription);
    return /*#__PURE__*/ React__default.createElement(PrescriptionFormStep, {
        description: prescriptionFormStep === null || prescriptionFormStep === void 0 ? void 0 : prescriptionFormStep.description,
        image: prescriptionFormStep === null || prescriptionFormStep === void 0 ? void 0 : prescriptionFormStep.image,
        isLoading: isLoading,
        isFailed: isFailed,
        errorMessage: errorMessageKey ? getLabel(errorMessageKey) : '',
        errorMessageId: PRESCRIPTION_STEP_FORM_ERROR_ID,
        alertLabel: hasLabel(alertLabelKey) ? getLabel(alertLabelKey) : ''
    });
};

export { PrescriptionFormStepContainer };
//# sourceMappingURL=PrescriptionFormStepContainer.js.map
